import { useAuthStore } from '@/shared/store/auth-store'

export function useAuthSession() {
  const login = useAuthStore((state) => state.login)
  const rememberMe = useAuthStore((state) => state.rememberMe)
  const setRememberMe = useAuthStore((state) => state.setRememberMe)

  return {
    login,
    rememberMe,
    setRememberMe,
  }
}
